module.exports = "## Online Image Editor\r\n\r\nWith our image editor, you can perform the following actions: crop photo, flip images horizontally or vertically, or rotate an image. When cropping a photo, you can choose to keep the original aspect ratio by locking the crop tool. Alternatively, you can select different crop ratios such as 1:1 or 16:9."


//////////////////
// WEBPACK FOOTER
// ./src/containers/ImageResize/online-image-editor.md
// module id = 1178
// module chunks = 0